import React from "react";

export const Holdings = () => {
  return (
    <div>
      <div className="header">
        <h1 className="header-title">Holdings Chart</h1>
        <p className="header-subtitle">
          You have 24 new messages and 5 new notifications.
        </p>
      </div>
      <div className="px-6 py-4">Holdings Chart</div>
    </div>
  );
};
